import dayjs from "../../../utils/dayjs";
import { Alert, Form } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { miutesMaximumDefault } from "../../../shared/components/CustomForm/form.helpers";

export const DurationHourChecker = ({ keys, isLongDuration = false }) => {
  // if (dataForm?.[keys[0]] === undefined || dataForm?.[keys[1]] === undefined) {
  //   return <></>;
  // }

  const { t } = useTranslation();

  const start = Form.useWatch(keys[0]);
  const end = Form.useWatch(keys[1]);

  if (start === undefined || end === undefined) {
    return <></>;
  }

  const durationMinutes = end.diff(start, "minute");

  // Calculate hours and remaining minutes
  const durationHours = Math.floor(durationMinutes / 60);
  const remainingMinutes = durationMinutes % 60;

  // Function to handle pluralization
  const pluralize = (count, singular, plural) =>
    count <= 1 ? singular : plural;

  let isAdmin = onlyRoleMapping([roles.admin, roles.permanance]);

  let minutesMaximum;

  if (isAdmin || isLongDuration === true) {
    minutesMaximum = 480;
  } else {
    minutesMaximum = miutesMaximumDefault;
  }

  // Check if the duration is more than 8 hours (480 minutes) or less than 1 hour (60 minutes)
  if (durationMinutes >= minutesMaximum) {
    const description = (
      <span>
        {t("durationHourChecker.duration")}{" "}
        <b>
          {durationHours}{" "}
          {pluralize(
            durationHours,
            t("durationHourChecker.hourSingular"),
            t("durationHourChecker.hourPlural"),
          )}
        </b>
        {remainingMinutes > 0 ? (
          <>
            {" "}
            e{" "}
            <b>
              {remainingMinutes}{" "}
              {pluralize(
                remainingMinutes,
                t("durationHourChecker.minuteSingular"),
                t("durationHourChecker.minutePlural"),
              )}
            </b>
          </>
        ) : (
          ""
        )}
      </span>
    );

    const lessOneMinute = (
      <span>
        La durée de la prestation est de <b>moins d'une minute.</b>
      </span>
    );

    return (
      <Alert
        key={durationMinutes}
        style={{ width: "100%" }}
        message={t(`durationHourChecker.errorMessage`)}
        description={
          durationMinutes === 0 && durationHours <= 0
            ? lessOneMinute
            : description
        }
        type="error"
        showIcon
        closable={true}
      />
    );
  } else if (durationMinutes < 0) {
    return (
      <Alert
        key={durationMinutes}
        style={{ width: "100%" }}
        message={t(`durationHourChecker.errorMessage`)}
        type="error"
        showIcon
        closable={true}
      />
    );
  } else {
    return null;
  }
};
